export default __webpack_public_path__ + "static/telepointers-0d57c1976a2e29374470a59a884235e1.png";